import { ApiError } from "./api/error";

const PERMISSION_ERROR_MESSAGES: Record<string, string> = {
  PROJECT_ACCESS_DENIED: "You don't have access to this project.",
  PROJECT_EDIT_FORBIDDEN: "You don't have permission to edit this project.",
  JOB_ACCESS_DENIED: "You don't have access to this job.",
  JOB_EDIT_FORBIDDEN: "You don't have permission to edit this job.",
  JOB_MANAGER_ACCESS_DENIED: "You don't have access to this job manager.",
  JOB_MANAGER_PROJECT_ACCESS_DENIED:
    "The job manager doesn't have access to this project.",
  ORG_ACCESS_DENIED: "You don't have access to this organization.",
  ORG_NOT_FOUND: "No active organization. Please select or create one.",
  FORBIDDEN: "You don't have permission for this action.",
};

const PERMISSION_ERROR_CODES = new Set(Object.keys(PERMISSION_ERROR_MESSAGES));

// Payment-method 403s carry the generic FORBIDDEN code, so they can't be mapped
// to specific copy by code; billing call sites use this message directly.
export const PAYMENT_METHOD_FORBIDDEN_MESSAGE =
  "Only org admins can manage payment methods.";

export function isPermissionError(error: unknown): error is ApiError {
  return error instanceof ApiError && PERMISSION_ERROR_CODES.has(error.code);
}

export function isPermissionDenied(error: unknown): error is ApiError {
  if (!(error instanceof ApiError)) return false;
  return error.status === 403 || PERMISSION_ERROR_CODES.has(error.code);
}

export function getPermissionErrorMessage(error: unknown): string {
  if (error instanceof ApiError && PERMISSION_ERROR_MESSAGES[error.code]) {
    return PERMISSION_ERROR_MESSAGES[error.code];
  }
  if (error instanceof ApiError && error.status === 403) {
    return "You don't have permission for this action.";
  }
  return "An unexpected error occurred.";
}

export function shouldRedirectOnPermissionError(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;
  return (
    error.code === "PROJECT_ACCESS_DENIED" ||
    error.code === "JOB_ACCESS_DENIED" ||
    error.code === "ORG_ACCESS_DENIED" ||
    error.code === "ORG_NOT_FOUND"
  );
}

export function isOrgMissing(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;
  return (
    error.code === "ORG_NOT_FOUND" || error.code === "NO_ACTIVE_ORG"
  );
}
